import { render, staticRenderFns } from "./ByLoadingFeedback.vue?vue&type=template&id=349ca650&scoped=true"
import script from "./ByLoadingFeedback.vue?vue&type=script&lang=js"
export * from "./ByLoadingFeedback.vue?vue&type=script&lang=js"
import style0 from "./ByLoadingFeedback.vue?vue&type=style&index=0&id=349ca650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ca650",
  null
  
)

export default component.exports